import { Navigate } from 'react-router-dom';
import { useUserPreferences } from '@/contexts/UserPreferencesContext';
import { HomeDashboard } from '@/pages/HomeDashboard';
import { HOME_LANDING_PAGE, useLandingPageItems } from '@/hooks/useLandingPages';

/**
 * `/` opens the user's chosen landing page while it is still one they may choose. A page they have
 * since lost the permission for, or whose module the tenant switched off, falls back to the home
 * dashboard — as does no choice at all.
 */
export function LandingPageRedirect() {
  const { landingPage, isLoading } = useUserPreferences();
  const choices = useLandingPageItems();

  if (isLoading) return null;
  if (landingPage !== HOME_LANDING_PAGE && choices.some(item => item.path === landingPage)) {
    return <Navigate to={landingPage} replace />;
  }
  return <HomeDashboard />;
}
